import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { PlacementContext } from 'src/types/PlacementContext';

export type CarouselTrackingDirection = 'next' | 'previous';

interface CarouselNavigationContext extends PlacementContext {
  numberOfItems: number;
}

export const trackCarouselNavigation = (
  swiped: boolean,
  direction: CarouselTrackingDirection,
  {
    placementContentType,
    trackingPosition,
    trackingTitle,
    numberOfItems,
  }: CarouselNavigationContext,
) => {
  const navigationType = swiped ? 'Swipe' : 'Arrow click';
  sendGAEvent({
    event: 'custom_event',
    event_action: `${navigationType} ${direction}`,
    event_category: `${trackingPosition} | ${placementContentType}`,
    event_label: `${trackingPosition} | ${trackingTitle} | ${numberOfItems}`.toLowerCase(),
    event_name: 'content_interaction',
    event_details: `${navigationType} ${direction}`.toLowerCase(),
    content_position: `${trackingPosition}`,
    content_type: `${placementContentType}|${trackingTitle}`.toLowerCase(),
    total_options: `${numberOfItems}`,
  });
};
